import { useCallback, useState } from 'react';

export type AlertCopy = { title: string; body: string };

export function useAlertWarning() {
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [alertCopy, setAlertCopy] = useState<AlertCopy>();

    const openAlert = useCallback((copy: AlertCopy) => {
        setAlertCopy(copy);
        setIsAlertOpen(true);
    }, []);

    const closeAlert = useCallback(() => {
        setIsAlertOpen(false);
    }, []);

    return { isAlertOpen, alertCopy, openAlert, closeAlert };
}
